const translation = {
  pageTitle: 'Hej, začnimo!👋',
  welcome: 'Dobrodošli v Dify, prosimo, prijavite se za nadaljevanje.',
  email: 'E-poštni naslov',
  emailPlaceholder: 'Vaš e-poštni naslov',
  password: 'Geslo',
  passwordPlaceholder: 'Vaše geslo',
  name: 'Uporabniško ime',
  namePlaceholder: 'Vaše uporabniško ime',
  forget: 'Ste pozabili geslo?',
  signBtn: 'Prijava',
  sso: 'Nadaljujte z SSO',
  installBtn: 'Namesti',
  setAdminAccount: 'Nastavitev administratorskega računa',
  setAdminAccountDesc: 'Najvišje pravice za administratorski račun, ki se lahko uporablja za ustvarjanje aplikacij in upravljanje LLM ponudnikov itd.',
  createAndSignIn: 'Ustvari in prijavi se',
  oneMoreStep: 'Še en korak',
  createSample: 'Na podlagi teh informacij bomo za vas ustvarili vzorčno aplikacijo',
  invitationCode: 'Vabilna koda',
  invitationCodePlaceholder: 'Vaša vabilna koda',
  interfaceLanguage: 'Jezik vmesnika',
  timezone: 'Časovni pas',
  go: 'Pojdi na Dify',
  sendUsMail: 'Pošljite nam uvod po e-pošti, mi pa bomo obravnavali vašo zahtevo za vabilo.',
  acceptPP: 'Prebral sem in sprejemam politiko zasebnosti',
  reset: 'Za ponastavitev gesla zaženite naslednji ukaz',
  withGitHub: 'Nadaljujte z GitHub',
  withGoogle: 'Nadaljujte z Google',
  rightTitle: 'Odklenite polni potencial LLM',
  rightDesc: 'Brez napora gradite vizualno privlačne, operabilne in izboljšljive AI aplikacije.',
  tos: 'Pogoji storitve',
  pp: 'Politika zasebnosti',
  tosDesc: 'Z registracijo se strinjate z našimi',
  goToInit: 'Če računa še niste inicializirali, pojdite na stran za inicializacijo',
  dontHave: 'Nimate?',
  invalidInvitationCode: 'Neveljavna vabilna koda',
  accountAlreadyInited: 'Račun je že inicializiran',
  forgotPassword: 'Ste pozabili geslo?',
  resetLinkSent: 'Povezava za ponastavitev poslana',
  sendResetLink: 'Pošlji povezavo za ponastavitev',
  backToSignIn: 'Nazaj na prijavo',
  forgotPasswordDesc: 'Prosimo, vnesite svoj e-poštni naslov za ponastavitev gesla. Poslali vam bomo e-pošto z navodili za ponastavitev gesla.',
  checkEmailForResetLink: 'Preverite svojo e-pošto za povezavo za ponastavitev gesla. Če je ne prejmete v nekaj minutah, preverite tudi mapo z neželeno pošto.',
  passwordChanged: 'Prijavite se zdaj',
  changePassword: 'Spremeni geslo',
  changePasswordTip: 'Prosimo, vnesite novo geslo za svoj račun',
  invalidToken: 'Neveljaven ali potekel žeton',
  confirmPassword: 'Potrdite geslo',
  confirmPasswordPlaceholder: 'Potrdite svoje novo geslo',
  passwordChangedTip: 'Vaše geslo je bilo uspešno spremenjeno',
  error: {
    emailEmpty: 'E-poštni naslov je obvezen',
    emailInValid: 'Prosimo, vnesite veljaven e-poštni naslov',
    nameEmpty: 'Ime je obvezno',
    passwordEmpty: 'Geslo je obvezno',
    passwordLengthInValid: 'Geslo mora vsebovati vsaj 8 znakov',
    passwordInvalid: 'Geslo mora vsebovati črke in številke, dolžina pa mora biti več kot 8 znakov',
    registrationNotAllowed: 'Računa ni mogoče najti. Za registracijo se obrnite na skrbnika sistema.',
  },
  license: {
    tip: 'Preden začnete z Dify Community Edition, preberite GitHub',
    link: 'Licenco odprte kode',
  },
  join: 'Pridruži se',
  joinTipStart: 'Vabimo vas, da se pridružite',
  joinTipEnd: 'ekipi na Dify',
  invalid: 'Povezava je potekla',
  explore: 'Razišči Dify',
  activatedTipStart: 'Pridružili ste se ekipi',
  activatedTipEnd: 'ekipi',
  activated: 'Prijavite se zdaj',
  adminInitPassword: 'Geslo za inicializacijo administratorja',
  validate: 'Potrdi',
  checkCode: {
    emptyCode: 'Koda je obvezna',
    verificationCodePlaceholder: 'Vnesite 6-mestno kodo',
    resend: 'Poslati',
    verificationCode: 'Koda za preverjanje',
    tips: 'Kodo za preverjanje pošljemo na <strong>{{email}}</strong>',
    verify: 'Preveriti',
    validTime: 'Upoštevajte, da je koda veljavna 5 minut',
    checkYourEmail: 'Preverjanje e-pošte',
    didNotReceiveCode: 'Niste prejeli kode?',
    invalidCode: 'Neveljavna koda',
    useAnotherMethod: 'Uporabite drug način',
  },
  useVerificationCode: 'Uporaba kode za preverjanje',
  licenseInactive: 'Licenca je neaktivna',
  changePasswordBtn: 'Nastavitev gesla',
  licenseExpired: 'Licenca je potekla',
  resetPassword: 'Ponastavi geslo',
  back: 'Hrbet',
  backToLogin: 'Nazaj na prijavo',
  enterYourName: 'Prosimo, vnesite svoje uporabniško ime',
  licenseLost: 'Izgubljena licenca',
  licenseExpiredTip: 'Licenca za Dify Enterprise za vaš delovni prostor je potekla. Če želite še naprej uporabljati Dify, se obrnite na skrbnika.',
  usePassword: 'Uporaba gesla',
  sendVerificationCode: 'Pošlji kodo za preverjanje',
  resetPasswordDesc: 'Vnesite e-poštni naslov, ki ste ga uporabili za prijavo na Dify, in poslali vam bomo e-poštno sporočilo za ponastavitev gesla.',
  setYourAccount: 'Nastavitev računa',
  noLoginMethodTip: 'Obrnite se na skrbnika sistema, da dodate način preverjanja pristnosti.',
  or: 'ALI',
  noLoginMethod: 'Način preverjanja pristnosti ni konfiguriran',
  continueWithCode: 'Nadaljujte s kodo',
  withSSO: 'Nadaljujte z enotno prijavo',
  licenseLostTip: 'Povezava z licenčnim strežnikom Dify ni uspela. Če želite še naprej uporabljati Dify, se obrnite na skrbnika.',
  licenseInactiveTip: 'Licenca Dify Enterprise za vaš delovni prostor je neaktivna. Če želite še naprej uporabljati Dify, se obrnite na skrbnika.',
  webapp: {
    noLoginMethod: 'Metoda overjanja ni nastavljena za spletno aplikacijo',
    noLoginMethodTip: 'Prosimo, da se obrnete na sistemskega skrbnika, da dodate metodo za avtentikacijo.',
    disabled: 'Avtentikacija v spletni aplikaciji je onemogočena. Prosimo, kontaktirajte skrbnika sistema, da jo omogoči. Poskusite lahko neposredno uporabljati aplikacijo.',
  },
}

export default translation
